module.exports = __webpack_public_path__ + "img/head-bg.979a9176.png";